export function  getMailstatusColor(statusName: string): string {

  const statusMap: { [key: string]: string } = {
    sent: 'warning',
    accepted: 'warning',
    delivered: 'primary',
    failed: 'danger',
    bounced: 'danger',
    temporary_fail: 'danger',
    permanent_fail: 'danger',
  };

  return statusMap[statusName] ?? 'secondary';
}
